var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderCollected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10344",
    "data-name": "Group 10344",
    transform: "translate(-29.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(29.5)",
    fill: "#01b762"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10336",
    "data-name": "Group 10336",
    transform: "translate(-4.387 -1.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "server",
    transform: "translate(48.003 17.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M9.677-212.76c-.149.014-.523.068-.829.122-.652.122-8.183,1.976-8.462,2.085a.6.6,0,0,0-.387.625c0,.224,1.494,5.935,1.806,6.913a.666.666,0,0,0,.74.53c.17,0,1.63-.149,3.253-.34l2.954-.333L13-201.392c2.343.971,4.441,1.813,4.679,1.881a6.9,6.9,0,0,0,2.744-.034c.238-.081,1.9-.72,3.7-1.419l3.266-1.284,2.825-2.642c4.8-4.489,4.489-4.143,4.543-5.154a1.485,1.485,0,0,0-.183-1.032,1.861,1.861,0,0,0-1.025-.978,2.46,2.46,0,0,0-1.576-.088c-.177.061-5.569,3.694-5.813,3.918a2.468,2.468,0,0,0,.088.5,2.614,2.614,0,0,1-.638,2.54,2.917,2.917,0,0,1-2.16.93c-.557,0-6.771-1.114-7.076-1.27a.617.617,0,0,1-.007-1.121c.238-.115.278-.109,3.6.5a25.662,25.662,0,0,0,3.667.564,1.454,1.454,0,0,0,1.3-2.017,2.248,2.248,0,0,0-1.019-1.161c-.659-.333-9.243-3.531-9.962-3.715a12.9,12.9,0,0,0-1.406-.258A22.383,22.383,0,0,0,9.677-212.76Z",
    transform: "translate(0 232.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M18027.439,21269.383a1.982,1.982,0,0,1-1.979-1.984v-12.855a.986.986,0,0,1,.289-.7l2.965-2.965a.967.967,0,0,1,.7-.289h11.871a.969.969,0,0,1,.7.289l2.965,2.965a1,1,0,0,1,.291.7v12.855a1.987,1.987,0,0,1-1.982,1.984Zm0-1.984h15.832l-.008-11.863h-15.824Zm1.4-13.844h13.021l-.984-.992h-11.049Zm-.119,9.527v-5.3h2.654v2.652h7.955v-2.652h2.652v5.3Z",
    transform: "translate(-18012.307 -21250.59)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCollected);
export default __webpack_public_path__ + "static/media/order-collected.611b0039540f135d22b11aa1527dac18.svg";
export { ForwardRef as ReactComponent };